import { SLButtonGroupAnrufenBuchen } from "@/components/buttons/SLButtonGroupAnrufenBuchen";
import { Stack, Typography, useTheme } from "@mui/material";
import { motion } from "motion/react";
import { useEffect, useRef } from "react";
import { NumericFormat } from "react-number-format";

interface SLCalcResultDisplayProps {
  untergrenze: string;
  obergrenze: string;
  isActive: boolean;
}

export const SLCalcResultDisplay = ({
  untergrenze,
  obergrenze,
  isActive,
}: SLCalcResultDisplayProps) => {
  const theme = useTheme();
  const divRef = useRef<HTMLDivElement>(null);

  const scrollToElement = () => {
    const { current } = divRef;

    if (current !== null) {
      current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  useEffect(() => {
    if (isActive) {
      scrollToElement();
    }
  }, [isActive]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <Stack
        ref={divRef}
        sx={{
          py: 1,
          px: 2,
          borderRadius: `${theme.shape.borderRadius}px`,
          backgroundColor: theme.palette.success.light,
          width: "100%",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          component="p"
          color={theme.palette.success.dark}
          variant="h4"
          sx={{ fontWeight: 600, pt: 1 }}
        >
          Ergebnis
        </Typography>

        <Typography variant="body1">
          Eine faire Abfindung liegt geschätzt
        </Typography>

        <Typography textAlign={"center"}>
          <Typography fontWeight={400} component={"span"} variant="body1">
            {" zwischen "}
          </Typography>

          <Typography component="span" variant="h6" textAlign={"center"}>
            <NumericFormat
              value={untergrenze}
              displayType="text"
              thousandSeparator={"."}
              decimalScale={0}
              suffix=" €"
              decimalSeparator={","}
            />
          </Typography>
          <Typography fontWeight={400} component={"span"} variant="body1">
            {" und "}
          </Typography>
          <Typography component="span" variant="h6" textAlign={"center"}>
            <NumericFormat
              value={obergrenze}
              displayType="text"
              thousandSeparator={"."}
              decimalScale={0}
              suffix=" €"
              decimalSeparator={","}
            />
          </Typography>
        </Typography>
        <SLButtonGroupAnrufenBuchen
          size="small"
          isEmphasizedFreeInitialConsultation={true}
        />
      </Stack>
    </motion.div>
  );
};
